import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { GetWidgetService, IWidget } from '../../../services/get-widget.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, Router } from '@angular/router';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';


declare var CP: any;

@Component({
  selector: 'app-get-widget',
  templateUrl: './get-widget.component.html',
  styleUrls: ['./get-widget.component.scss'],
})
export class GetWidgetComponent implements OnInit {
  displayStep: number;
  previewUrl: string;
  defaultImageUrl: string;
  rootScopeData: RootScopeDeclare;
  currentFacility: FacilityObject;
  cloudBasePath: string;
  fnName: string;
  filesInput: FileList | null;
  selectedFile: File | null;
  isInvalidFileFormat = false;
  widgetData: IWidget;
  pic: any;
  // widgetData: IWidget = {
  //   'facilityId':'',
  //   'fontColor':'#EB5F60',
  //   'logo':'https://storage.googleapis.com/sg-office/qa/adtool/widgetlogo/3822c3eb-f8df-487a-b247-d34f16229ddfImage_Microsite_Logo_LifeFitness.png?GoogleAccessId=gcs-svc@lfco-qa-191202.iam.gserviceaccount.com&Expires=3175930493&Signature=lgO7WLhfH%2FhtObfWLXCGLcc5c852FQwEglfMEcfSCLON4GJdhTWo%2FIIawtkFxd2xn2wRSspyJelBv5HhWyJjRmkcaX7n7zYtuTQxCCfGMRhQCuBPCALURWA7T83fpP1Fg6tb%2FDLpGAz9pHeJnkenXcoohnN6Osqq4RBAP%2BhQd8h51K85VhnXOofIfXS6ro%2BN%2Fm3Cyan14fMmIfOi%2FTG%2FFYna5udBH%2BPI%2B0hTlyRFqxEX%2FveX8Lt1amJz7Z24gvxqYABVuR34GqRwfmVVjMwRMcUJgBAnHL6gTDA5mkV8TWlVh8iv2NYo4V72bfqpIci7%2FrPkjRq6pG7xgFkD1AEy%2Bg%3D%3D',
  //   'language':'',
  //   'facilityHoursStart': 0,
  //   'facilityMinsStart': 0,
  //   'facilityHoursEnd': 0,
  //   'facilityMinsEnd': 0,
  //   'widgetPath': ''
  // };

  // remove the default values if its not needed

  // subscriptions
  private _facilityOnChange: Subscription;

  uploadForm: FormGroup;
  facilityHoursStart: number;
  facilityMinsStart: number;
  facilityHoursEnd: number;
  facilityMinsEnd: number;
  language: string;
  facilityId: string;
  fontColor: string;
  initializeColorPicker = false;
  logo: string;
  widgetinput: {
    facilityId: string;
    fontColor: string;
    logo: string;
    language: string;
    facilityHoursStart: number;
    facilityMinsStart: number;
    facilityHoursEnd: number;
    facilityMinsEnd: number;
  };
  step3data: { language: string; openTime: string; closeTime: string } | undefined;
  widgetPath: string | undefined;
  facilityOperatinghours: {
    facilityHoursStart: number;
    facilityMinsStart: number;
    facilityHoursEnd: number;
    facilityMinsEnd: number;
    language:string;
  };

  constructor(
    private rootScopeService: RootScopeService,
    private _facilityService: FacilityService,
    private _widgetService: GetWidgetService,
    private formBuilder: FormBuilder,
    private _cookieService: CookieService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
    private _route: ActivatedRoute,
    private _router: Router,
    private loader: HaloLoaderService
  ) { }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this.rootScopeData = rootScopeData;
    });
  }

  ngOnInit(): void {
    this.initGetWidget();
    window.addEventListener('scroll', this.scroll, true); // third parameter
  }

  scroll = (event: Event): void => {
    // handle your scroll here
    // notice the 'odd' function assignment to a class field
    // this is used to be able to remove the event listener
    if (this.pic) {
      if (!this.pic._initScrollPosition) { return; }
      this.pic.self.style.marginTop = (this.pic._initScrollPosition.y + 28 - (event.target as Element).scrollTop) + 'px';
    }
  }

  trackChooseColor(): void {
    //
  }

  updateColorPicker(updateFlag: boolean): void{
    if(updateFlag)
      this.rootScopeData.isPageHasUnsavedChanges = true;
    const elem: any = document.querySelector('#colorpickerinput');
    const btnelem: any = document.querySelector('#colorpickerbtn');
    let pattern:any = new RegExp("^#([a-fA-F0-9]){3}$|[a-fA-F0-9]{6}$");
    if(!pattern.test(elem.value)) {
      elem.value = '#000000';
    }
    this.widgetData.fontColor = elem.value;
    btnelem.style.backgroundColor = elem.value;
    this.previewUrl =
        environment.assetsPath +
        '/microsite-preview/microsite-preview.html?c=' +
        encodeURIComponent(this.widgetData.fontColor) +
        '&l=' +
        encodeURIComponent(this.widgetData.logo);
  }

  initColorPicker(): void {
    const elem: any = document.querySelector('#colorpickerinput');
    const btnelem: any = document.querySelector('#colorpickerbtn');
    btnelem.style.backgroundColor = this.widgetData.fontColor;
    btnelem.value = this.widgetData.fontColor;
    elem.value = this.widgetData.fontColor;
    this.pic = new CP(btnelem);    
    this.pic.on('change', (r: any, g: any, b: any, a: any) => {
      if (this.initializeColorPicker) {
        this.trackChooseColor();
        this.rootScopeData.isPageHasUnsavedChanges = true;
      }
      btnelem.style.backgroundColor = this.pic.color(r, g, b, a);
      elem.value = this.pic.color(r, g, b, a);
      this.widgetData.fontColor = this.pic.color(r, g, b, a);
      this.previewUrl =
        environment.assetsPath +
        '/microsite-preview/microsite-preview.html?c=' +
        encodeURIComponent(this.widgetData.fontColor) +
        '&l=' +
        encodeURIComponent(this.widgetData.logo);
      this.initializeColorPicker = true;
    });
    this.pic.on('enter', () => {      
      this.pic.value.apply(this.pic, CP.HEX(this.widgetData.fontColor));
      this.pic._initScrollPosition = {
        y: 0
      };
      this.pic.self.style.marginTop = '0px';
    });
  }

  ngOnDestroy() {
    // destroy subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
    window.removeEventListener('scroll', this.scroll, true);
  }

  /* sTART step 1 logic*/
  initGetWidget(): void {
    this.getRootScopeData();
    this.rootScopeData.pageName = 'Facility - Equipment';
    this.displayStep = 1;
    this.currentFacility = this._facilityService.selectedFacility();
    this.cloudBasePath = environment.cloudBasePath;

    // subscript facility change / when facility change
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.currentFacility = res;
      if(this.currentFacility.summary.facilityRights.micrositeWidget  === 'true' &&      
      this.currentFacility.summary.isLoggedInManagerAdmin === 'true'){
        this.fetchWidgetDetails(true);
      }else{
        this._router.navigate(["/facility/equipment"]);
      }
      
    });

    if (this.currentFacility.facilityId) {
      if(this.currentFacility.summary.facilityRights.micrositeWidget  === 'true' &&      
      this.currentFacility.summary.isLoggedInManagerAdmin === 'true'){
        this.fetchWidgetDetails(false);
      }else{
        this._router.navigate(["/facility/equipment"]);
      }      
    }

  }

  fetchWidgetDetails(updateFlag:boolean):void{
    this.loader.startProcess();
    this._widgetService.getWidgetDetails(this.currentFacility.facilityId).subscribe(
      (data) => {
        this.widgetData = data;
        this.defaultImageUrl = this.widgetData.logo;
        this.facilityOperatinghours = {
          facilityHoursStart: this.widgetData.facilityHoursStart,
          facilityMinsStart: this.widgetData.facilityMinsStart,
          facilityHoursEnd: this.widgetData.facilityHoursEnd,
          facilityMinsEnd: this.widgetData.facilityMinsEnd,
          language:this.widgetData.language
        };
        if (data.widgetPath) {
          this.widgetPath = data.widgetPath;
        }
        this.previewUrl =
          environment.assetsPath +
          '/microsite-preview/microsite-preview.html?c=' +
          encodeURIComponent(this.widgetData.fontColor) +
          '&l=' +
          encodeURIComponent(this.widgetData.logo);
        // if (this._cookieService.get('showWidgetStep4') === 'true') {
        //   this.displayStep = 4;
        // }
        if (history.state.data === 'Step4') {
          this.displayStep = 4;
        }
        this.loader.endProcess();
        if(!updateFlag){
          this.initColorPicker();
        }
        else{
          const elem: any = document.querySelector('#colorpickerinput');
          elem.value = this.widgetData.fontColor;
          this.updateColorPicker(false);       
          this.filesInput = null;
          this.selectedFile = null;
          this.isInvalidFileFormat = false;
          this.step3data = undefined; 
          this.displayStep = 1;
          const elmnt =  document.getElementById('getwidget-container') as HTMLElement;
          elmnt.scrollIntoView({ behavior: 'smooth' });    
        }    
      },
      (error) => {
        this.loader.endProcess();
        // console.error('API failed.');
      }
    );
    
    this.uploadForm = this.formBuilder.group({
      files: [''],
    });  
  }

  onFileSelect(event: Event): void {
    this.filesInput = (event.target as HTMLInputElement).files;
    this.rootScopeData.isPageHasUnsavedChanges = true;
    if (this.filesInput) {
      if (!this._widgetService.checkFileExtension(this.filesInput[0])) {
        this.isInvalidFileFormat = true;
        return;
      } else {
        this.selectedFile = this.filesInput[0];
        this.isInvalidFileFormat = false;
        const file = this.selectedFile;
        const formData = new FormData();
        formData.append('file', file);
        this.loader.startProcess();
        this._widgetService.uploadImage(formData).subscribe(
          (data) => {
            this.previewUrl =
              environment.assetsPath +
              '/microsite-preview/microsite-preview.html?c=' +
              encodeURIComponent(this.widgetData.fontColor) +
              '&l=' +
              encodeURIComponent(data.logo);
            this.widgetData.logo = encodeURIComponent(data.logo);
            if (this.widgetData) {
              this.widgetData.logo = data.logo;
            }
            this.loader.endProcess();
          },
          (error) => {
            this.loader.endProcess();
            // console.error('API failed.');
          }
        );
      }
    } else {
      this.isInvalidFileFormat = false;
    }
  }

  onFileDelete() {
    this.filesInput = null;
    this.selectedFile = null;
    this.isInvalidFileFormat = false;
    this.previewUrl =
      environment.assetsPath +
      '/microsite-preview/microsite-preview.html?c=' +
      encodeURIComponent(this.widgetData.fontColor) +
      '&l=' +
      encodeURIComponent(this.defaultImageUrl);
    this.widgetData.logo = this.defaultImageUrl;
  }
  /* END step 1 logic*/

  onBack(): void {
    if (this.displayStep > 1) {
      this.displayStep = this.displayStep - 1;
      const elmnt =  document.getElementById('getwidget-container') as HTMLElement;
      elmnt.scrollIntoView({ behavior: 'smooth' });
    }
  }

  onNext(): void {
    if (this.displayStep < 4) {
      if(this.displayStep === 3){
        this.postWidgetData();
      }else{
        this.displayStep = this.displayStep + 1;
        const elmnt =  document.getElementById('getwidget-container') as HTMLElement;
        elmnt.scrollIntoView({ behavior: 'smooth' });  
      }          
    }
    
    if (this.step3data !== undefined) {

      let timeArray1: String[];
      let timeArray2: String[];
      timeArray1 = this.step3data['openTime'].split(':');
      timeArray2 = this.step3data['closeTime'].split(':');

      this.facilityHoursStart = parseInt(timeArray1[0].trim());
      this.facilityMinsStart = parseInt(timeArray1[1].trim());
      this.facilityHoursEnd = parseInt(timeArray2[0].trim());
      this.facilityMinsEnd = parseInt(timeArray2[1].trim());

      this.facilityOperatinghours = {
        facilityHoursStart: this.facilityHoursStart,
        facilityMinsStart:  this.facilityMinsStart,
        facilityHoursEnd: this.facilityHoursEnd,
        facilityMinsEnd: this.facilityMinsEnd,
        language:this.step3data['language']
      };
    }

  }

  onCancel(): void {
    if (this.rootScopeData.isPageHasUnsavedChanges) {
      this.rootScopeData.showUnSavedChangesModal = true;
      this.rootScopeData.pathToNavigate = '/facility/equipment'
    } else {
      this._router.navigate(["/facility/equipment"]);
    }
  }
  getStep3Details(step3data: { language: string; openTime: string; closeTime: string }) {
    this.step3data = step3data;
  }
  postWidgetData(): void {
    let timeArray1: String[];
    let timeArray2: String[];
    

    if(this.step3data){
      timeArray1 = this.step3data['openTime'].split(':');
      timeArray2 = this.step3data['closeTime'].split(':');
      this.language = this.step3data['language'];

      this.facilityHoursStart = parseInt(timeArray1[0].trim());
      this.facilityMinsStart = parseInt(timeArray1[1].trim());
      this.facilityHoursEnd = parseInt(timeArray2[0].trim());
      this.facilityMinsEnd = parseInt(timeArray2[1].trim());
      this.currentFacility.summary.facilityHoursStart = this.facilityHoursStart.toString();
      this.currentFacility.summary.facilityMinsStart = this.facilityMinsStart.toString();
      this.currentFacility.summary.facilityHoursEnd = this.facilityHoursEnd.toString();
      this.currentFacility.summary.facilityMinsEnd = this.facilityMinsEnd.toString();
    }
    
    this.facilityId = this.currentFacility.facilityId;
    this.fontColor = this.widgetData.fontColor;
    this.widgetinput = {
      facilityId: this.facilityId,
      fontColor: this.widgetData.fontColor,
      logo: this.widgetData.logo,
      language: this.language,
      facilityHoursStart: this.facilityHoursStart,
      facilityMinsStart: this.facilityMinsStart,
      facilityHoursEnd: this.facilityHoursEnd,
      facilityMinsEnd: this.facilityMinsEnd,
    };
    this.loader.startProcess();    
    this._amplitudeAnalytics.logEvent({elementName: 'Next', action: 'Submit'});
    this._widgetService.postWidgetDetails(this.widgetinput).subscribe(
      (data) => {
        this.rootScopeData.isPageHasUnsavedChanges = false;
        this.widgetData = data;
        this.widgetPath = data.widgetPath;
        this.loader.endProcess();
        this.displayStep = this.displayStep + 1;
        const elmnt =  document.getElementById('getwidget-container') as HTMLElement;
        elmnt.scrollIntoView({ behavior: 'smooth' }); 
      },
      (error) => {
        this.rootScopeData.isPageHasUnsavedChanges = false;
        this.loader.endProcess();
        console.error('API failed.');
        return false;
        //FACILITY.OPERATION.HOURS.CLOSING.BEFORE.OPENING
      }
    );
  }
}
